import { Fragment, useState } from "react";
import DateField from "../TextField/dateTime";
import DropDown from "../SearchableSelect";
import { useLocation } from "react-router-dom";

const initialNotifyFilter = {
  fromDateRange: null,
  toDateRange: null,
  messageStatus: { name: "All", id: null },
  searchText: "",
  isArchived: false
};
// const readList = [
//   { name: "All", id: null },
//   { name: "Read", id: 1 },
//   { name: "Unread", id: 0 },
//   { name: "Archived", id: 2 },
// ];

// const IncidentReportList = [
//   { name: "All", id: '' },
//   { name: "New", id: 0 },
//   { name: "Resolved", id: 1 },
//   { name: "Archived", id: 3 },
// ]

// const notification_and_uploads_List = [
//   { name: "All", id: null },
//   { name: "Read", id: 1 },
//   { name: "Unread", id: 2 },
//   { name: "Archived", id: 3 },
// ]


const NotifyFilter = ({notifyParamChanges, readList}) => {
  const [notifyFilter, setNotifyFilter] = useState(initialNotifyFilter);
  const notificationParamHandler = (target) => {
    const {name,value} = target;
    setNotifyFilter(prev => ({...prev,[name]:value}))
  };
  const dropDownHandler = target => {
    const {name,value} = target;
    setNotifyFilter(prev => ({...prev,[name]:value}))
  }
  const searchTextChangeHandler = e => {
    const {name,value} = e.target;
    setNotifyFilter(prev => ({...prev,[name]:value}))
  }
  const archiveCheckboxHandler = e => {
    setNotifyFilter(prev => ({...prev,[e.target.name]:e.target.checked}))
  }
  const filterHandler = () => {
    notifyParamChanges(notifyFilter)
  };
  const clearFilterHandler = () => {
    setNotifyFilter(initialNotifyFilter);
    notifyParamChanges(initialNotifyFilter);
  }
  return (
    <Fragment>
      <section
        // style={{
        //   display: "grid",
        //   gridTemplateColumns: "repeat(5,minmax(0,1fr))",
        //   gap: "2rem",
        // }}
        className="d-flex gap-4 justify-content-evenly"
      >
        <DateField
          name={"fromDateRange"}
          divClass="w-20"
          label={"Received Date Range From"}
          id={"fromDateRange"}
          value={notifyFilter?.fromDateRange ? notifyFilter?.fromDateRange : ""}
          updateValue={notificationParamHandler}
          includeTime={false}
        />
        <DateField
          name={"toDateRange"}
          divClass="w-20"
          label={"Received Date Range To"}
          id={"toDateRange"}
          value={notifyFilter?.toDateRange ? notifyFilter?.toDateRange : ""}
          updateValue={notificationParamHandler}
          includeTime={false}
        />
        <DropDown
          name={"messageStatus"}
          // id={"jobCategory"}
          label="Read/Unread"
          options={readList}
          // disabled={}
          value={notifyFilter.messageStatus ? [notifyFilter.messageStatus] : []}
          multiple={false}
          updateValue={dropDownHandler}
          isObject={true}
          divClass={"w-20"}
        />
        <div className="">
          <label htmlFor="searchText">Search</label>
          <input
            type="text"
            className="form-control"
            placeholder="Search"
            name="searchText"
            id="searchText"
            value={notifyFilter.searchText}
            onChange={searchTextChangeHandler}
          />
        </div>
        <div className="d-flex flex-column mt-5 gap-2">
          <input type="checkbox" 
            name="isArchived"
            id="isArchived"
            onChange={archiveCheckboxHandler}
            value={notifyFilter.isArchived}
            checked={notifyFilter.isArchived}
          />
          <label>Archived</label>
        </div>
      </section>

      <section className="row pull-right">
        <div className="d-flex">
          <button className="btn btn-primary me-3" onClick={filterHandler}>
            Apply
          </button>
          <button className="btn btn-outline-primary" onClick={clearFilterHandler}>
            Clear Filter
          </button>
        </div>
      </section>
      
    </Fragment>
  );
};

export default NotifyFilter;
